export enum ClasseDiPrelievo {
    Uno = '1',
    Due = '2',
    Tre = '3',
}
